var render, staticRenderFns
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./edit.vue?vue&type=custom&index=0&blockType=div"
if (typeof block0 === 'function') block0(component)
import block1 from "./edit.vue?vue&type=custom&index=1&blockType=div"
if (typeof block1 === 'function') block1(component)

export default component.exports